import { create } from "zustand";
import { apiJson } from "@/lib/api/client";
import type { AdminMeAccessResponse } from "@/lib/api/types";

type AccessState = {
  roles: string[];
  rights: string[];
  loaded: boolean;
  loading: boolean;
  load: () => Promise<void>;
  clear: () => void;
  hasRight: (key: string) => boolean;
  hasAnyRight: (...keys: string[]) => boolean;
};

let inflight: Promise<void> | null = null;

export const useAdminAccessStore = create<AccessState>((set, get) => ({
  roles: [],
  rights: [],
  loaded: false,
  loading: false,
  load: () => {
    if (inflight) return inflight;
    set({ loading: true });
    inflight = (async () => {
      try {
        const json = await apiJson<AdminMeAccessResponse>("/admin/me/access");
        set({
          roles: json.roles ?? [],
          rights: json.rights ?? [],
          loaded: true,
          loading: false,
        });
      } catch {
        set({ roles: [], rights: [], loaded: true, loading: false });
      } finally {
        inflight = null;
      }
    })();
    return inflight;
  },
  clear: () => {
    inflight = null;
    set({ roles: [], rights: [], loaded: false, loading: false });
  },
  hasRight: (key) => {
    const needle = key.toLowerCase();
    return get().rights.some((r) => r.toLowerCase() === needle);
  },
  hasAnyRight: (...keys) => keys.some((k) => get().hasRight(k)),
}));
